import { baseService } from './baseService';

const restService = baseService.injectEndpoints({
  endpoints: (build) => ({
    fetchRestData: build.query<any, {
      url: string;
      method?: string;
      body?: any;
      cacheKey?: string;
      cache?: boolean;
      cacheLifetime?: number;
    }>({
      query: ({
        url,
        method = 'GET',
        body,
      }) => ({
        url,
        method,
        body,
      }),
    }),
  }),
});

// Export the generated hooks
export const { useLazyFetchRestDataQuery, useFetchRestDataQuery } = restService;
